import axios from "axios";
import store from "@/store";
import router from "@/router"
import api from "@/services/api"
export default class Helper {
    static clearToken() {
        store.commit("setAuthentication", false)
    }
    static setLoginDetails(data) {
        this.setLoginData(data);
        if (store.getters.authenticated == false) {
            router.push({ name: "Home" });
        } else {
            if(router.history.current.name === 'Home'){
                router.push({ name: "UserDashboard" })
            }else{
                router.push({ name: router.history.current.name }).catch(()=>{});
            }
        }
    }
    static setLoginData(data) {
        const userData = {
            id: data.user.id,
            name: data.user.name,
            biography: data.user.biography,
            email: data.user.email,
            mobile_number: data.user.mobile_number,
            country: data.user.country,
            address: data.user.address,
            city: data.user.city,
            avatar: data.user.avatar,
            avatar_path: data.user.avatar_path,
        }
        store.commit("setUserData", userData)
    }
    static clearUserData(){
        const userData = {
            id: "",
            name: "",
            email: "",
            mobile_number: "",
            country: "",
            address: "",
            city: "",
            avatar: "",
            avatar_path: "",
        }
        store.commit("setUserData", userData)
    }
    static logout() {
        // Best-effort: invalidate the server session too, but don't block
        // clearing local state on it (the cookie may already be gone).
        // Returns the request promise so callers can track completion
        // (e.g. the device-mismatch interceptor's re-entrancy guard).
        const request = axios.post(api.getUrl('/logout')).catch(() => {});
        this.clearToken();
        this.clearUserData();
        return request;
    }
    static setPropertyData(data) {
        const reqData = {
            address: data.formRequest.address,
        }
        store.commit("setReqPropertyData", reqData)
    }
    /**
     * convert object params to url
     */
    static objToUrlParams(obj) {
        let params = Object.keys(obj).map(key => obj[key]? encodeURIComponent(key) + "=" + encodeURIComponent(obj[key] ? obj[key] : ''):'');
        let filtered = params.filter(function (el) {
            return el != '';
        }).join("&");
        return filtered;
    }
    static showSpinner() {
        //Show loading. This is the only way to make it appear before the app is mounted.
        let spinnerWrapper = document.createElement('div');
        spinnerWrapper.className = 'spinner-wrapper';
        let spinner = document.createElement('div');
        spinner.className = 'spinner';
        spinnerWrapper.appendChild(spinner);
        let spinnerStyle = document.createElement('style');
       // spinnerStyle.textContent = ``;
        spinnerWrapper.appendChild(spinnerStyle);
        let appDiv = document.getElementById('app');
        appDiv.appendChild(spinnerWrapper);
    }
    /**
     * Hide spinner
     */
    static hideSpinner() {
        let div = document.getElementsByClassName('spinner-wrapper');
        if(div && div[0]){
          div[0].remove();
        }
    }

    static checkCurrentCourseStatus(cartItems , item_id){
        let status = false;
        if(cartItems){
            cartItems.some(item => {
                if(item.item_id === item_id){
                    status = true;
                }
            });
        }
        return status;
    }
    static getSelectItem(cartItems , item_id){
        let selectdItem = [];
        if(cartItems){
            cartItems.some(item => {
                if(item.item_id === item_id){
                    selectdItem = item;
                }
            });
        }
        return selectdItem;
    }
    static checkCurrentWishlistStatus(wishlistItems, item_id){
        let status = false;
        if(wishlistItems){
            wishlistItems.some(item => {
                if(item.item_id === item_id){
                    status = true;
                }
            });
        }
        return status;
    }
    static getSelectWishlistItem(wishlistItems , item_id){
        let wishlistItem = [];
        if(wishlistItems){
            wishlistItems.some(item => {
                if(item.item_id === item_id){
                    wishlistItem = item;
                }
            });
        }
        return wishlistItem;
    }
}